import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/ui';
import { useTheme } from '@/theme';

export type ScheduleRow = { day: string; time: string; title: string; teacher: string };

export function ScheduleList({ rows }: { rows: ScheduleRow[] }) {
  const theme = useTheme();
  return (
    <View style={{ borderTopWidth: 1, borderTopColor: theme.colors.rule }}>
      {rows.map((r, i) => (
        <View
          key={`${r.day}-${r.time}-${i}`}
          style={[styles.row, { borderBottomColor: theme.colors.rule }]}
        >
          <View style={styles.day}>
            <Text variant="eyebrow" tone="fgMute">{r.day}</Text>
            <Text variant="h3" style={{ marginTop: 4 }}>
              {r.time}
            </Text>
          </View>
          <View style={styles.title}>
            <Text
              style={{
                fontFamily: theme.fontFamily.displayItalic,
                fontStyle: 'italic',
                fontSize: 32,
                lineHeight: 36,
                color: theme.colors.fg,
              }}
            >
              {r.title}
            </Text>
          </View>
          <View style={styles.teacher}>
            <Text variant="meta" tone="fgMute">Lehrpersonen</Text>
            <Text variant="body" style={{ marginTop: 4 }}>{r.teacher}</Text>
          </View>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 24,
    paddingVertical: 24,
    borderBottomWidth: 1,
  },
  day: {
    flexBasis: 100,
    flexGrow: 0,
  },
  title: {
    flex: 1,
    minWidth: 240,
  },
  teacher: {
    flexBasis: 220,
    flexGrow: 0,
  },
});
